export function isInteractivePath(path: string | null | undefined): boolean {
  if (!path) return false;

  const pathParts = path.replace(/^\/+|\/+$/g, '').split('/');

  // check if first part is a 2-character region code
  if (pathParts[0]?.length === 2) {
    // remove the region prefix
    pathParts.shift();
  }

  if (pathParts.length === 0) {
    return false;
  }

  // check if the first part is an interactive path
  return (
    pathParts[0] === 'video' ||
    pathParts[0] === 'audio' ||
    pathParts[0] === 'guided-research' ||
    pathParts[0] === 'interactive'
  );
}
